import { z } from "zod"

export const timeTheftSchema = z.object({
   wage: z
      .number({ invalid_type_error: "Please enter a number" })
      .min(0.1, "Average hourly wage must be greater than 0"),
   minutes: z
      .number({ invalid_type_error: "Please enter a number" })
      .min(0, "Minutes stolen per employee per shift cannot be negative"),
   employees: z
      .number({ invalid_type_error: "Please enter a number" })
      .min(1, "Number of employees must be at least 1"),
   shifts: z.number({ invalid_type_error: "Please enter a number" }).min(1, "Shifts per week must be at least 1"),
   locations: z
      .number({ invalid_type_error: "Please enter a number" })
      .min(1, "Number of locations must be at least 1"),
})

export type TimeTheftFormValues = z.infer<typeof timeTheftSchema>
